module.exports = __webpack_public_path__ + "static/media/box.c8913ca1.svg";